import { Image, View } from "react-native";
import { appConfigStore } from "../app/stores/AppConfig";
import { Typography, useTheme, Box } from "@mui/material";
import { usePreviewableConfig } from "../contexts/PreviewConfigContext";

interface AppLogoProps {
	showText?: boolean;
	size?: number;
	sx?: any;
}

export const AppLogo = ({ showText = true, size = 50, sx = {} }: AppLogoProps) => {
	const darkMode = appConfigStore((state) => state.darkMode);
	const theme = useTheme();
	const { config } = usePreviewableConfig();

	// Check if appLogo is a URL, data URL, or local asset
	const isUrl = config.appLogo.startsWith('http://') || config.appLogo.startsWith('https://') || config.appLogo.startsWith('data:');

	const heroImage = isUrl
		? { uri: config.appLogo }
		: darkMode
			? require("../assets/icon-white-bg.svg")
			: require("../assets/icon-black-bg.svg");

	// Use Google Font if set, otherwise use local font
	const logoFontFamily = config.logoFont 
		? `'${config.logoFont}', sans-serif` 
		: 'logoFont';

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				marginTop: showText ? 1.5 : 0,
				...sx
			}}
		>
			<Image
				style={{
					width: size,
					aspectRatio: 1,
					resizeMode: "contain",
					borderRadius: size / 2, // 50% of width for a circle
				}}
				source={heroImage}
			/>
			{showText && (
				<Typography
					variant="h5"
					sx={{
						marginTop: 2.25,
						fontFamily: logoFontFamily,
						letterSpacing: 0.5,
						fontWeight: 900,
						color: theme.palette.text.primary
					}}
				>
					{config.appHeaderName}
				</Typography>
			)}
		</Box>
	);
};
